import styled, { css } from 'styled-components'
import theme from '../../styles/theme'

export const Title = styled.h2`
  color: ${theme.colors.primary};
  font-family: ${theme.font.comfortaa};
  margin-bottom: 5px;
  margin-top: 50px;
`
export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;

    > img {
      max-width: 100%;
    }

    > button {
      width: 50%;
      margin-top: 3%;
    }

    > span {
      font-size: ${theme.font.sizes.small};
      color: ${theme.colors.darkGray};
      text-align: center;
      margin-bottom: 16px;
    }
    p {
      font-size: 1.2rem;
      text-align: center;
      font-family: ${theme.font.comfortaa};
      color: ${theme.colors.darkGray};
      font-weight: 100;
      margin: 0;
    }
    .title-modal {
      margin: 0;
    }
    svg {
      position: relative;
    }

    .circle:before {
      content: '';
      width: 240px;
      height: 240px;
      background: #f5f5f5;
      display: block;
      position: absolute;
      border-radius: 50%;
    }

    .circle {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
  `}
`
